module.exports = __webpack_public_path__ + "img/modal-button-2.85892fbb.svg";